import { render, staticRenderFns } from "./Attach.vue?vue&type=template&id=79a545ca&scoped=true"
import script from "./Attach.vue?vue&type=script&lang=js"
export * from "./Attach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a545ca",
  null
  
)

export default component.exports